// assets
import { IconReplaceUser } from '@tabler/icons-react';

// constant
const icons = { IconReplaceUser };

// ==============================|| HR STAFF MENU ITEMS ||============================== //

const hrStaff = {
  id: 'hrStaff',
  title: 'HR Staff',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'HR Staff',
      type: 'item',
      url: '/hr-staff',
      icon: icons.IconReplaceUser,
      breadcrumbs: false
    }
  ]
};

export default hrStaff;
